import { Box, Button, Image, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react';

import SuccessIllustrator from 'Asset/image/success-illustrator.png';
import ErrorIllustrator from 'Asset/image/failed-illustrator.png';
import WarningIllustrator from 'Asset/image/warning-illustrator.png';

import { Condition } from 'Component/others';
import { useModal } from 'Store/modal';
import { useToast } from 'Store/toast';

import { TextBold, TextRegular, TextSemiBold } from 'UiKit/typography';
import { CloseIcon } from 'Asset/icon';

import styles from './styles.module.css';

const ModalSuccess = ({ modalProps }) => {
  const {
    contentTitle,
    contentDescription,
    showSecondaryButton,
    showPrimaryButton,
    onClickSecondaryButton,
    onResetModal,
    secondaryButtonText,
    onClickPrimaryButton,
    primaryButtonText,
    otherContent,
  } = modalProps;
  return (
    <>
      <ModalBody className={styles['modal__body']}>
        <Box className={styles['modal__success--body-container']}>
          <Box>
            <Image src={SuccessIllustrator} className={styles['modal__success--illustrator']} />
          </Box>
          <Box className={styles['modal__success--body']}>
            <Box className={styles['modal__success--body-content']}>
              <TextBold className={styles['modal__success--body-content-title']}>{contentTitle}</TextBold>
              <TextRegular className={styles['modal__success--body-content-description']}>{contentDescription}</TextRegular>
            </Box>
            {otherContent}
          </Box>
        </Box>
      </ModalBody>

      <Condition statement={showPrimaryButton || showSecondaryButton}>
        <ModalFooter className={styles['modal__footer']}>
          <Condition statement={showSecondaryButton}>
            <Button onClick={onClickSecondaryButton || onResetModal} className={styles['modal__button--secondary']}>
              <TextSemiBold className={styles['modal__text-secondary-button']}>{secondaryButtonText}</TextSemiBold>
            </Button>
          </Condition>
          <Condition statement={showPrimaryButton}>
            <Button className={styles['modal__success--primary-button']} onClick={onClickPrimaryButton}>
              <TextSemiBold className={styles['modal__text--primary-button']}>{primaryButtonText}</TextSemiBold>
            </Button>
          </Condition>
        </ModalFooter>
      </Condition>
    </>
  );
};

const ModalError = ({ modalProps }) => {
  const {
    contentTitle,
    contentDescription,
    showSecondaryButton,
    showPrimaryButton,
    onClickSecondaryButton,
    onResetModal,
    secondaryButtonText,
    onClickPrimaryButton,
    primaryButtonText,
    otherContent,
  } = modalProps;
  return (
    <>
      <ModalBody className={styles['modal__body']}>
        <Box className={styles['modal__error--body-container']}>
          <Box>
            <Image src={ErrorIllustrator} className={styles['modal__error--illustrator']} />
          </Box>
          <Box className={styles['modal__error--body']}>
            <Box className={styles['modal__error--body-content']}>
              <TextBold className={styles['modal__error--body-content-title']}>{contentTitle}</TextBold>
              <TextRegular className={styles['modal__error--body-content-description']}>{contentDescription}</TextRegular>
            </Box>
            {otherContent}
          </Box>
        </Box>
      </ModalBody>
      <Condition statement={showPrimaryButton || showSecondaryButton}>
        <ModalFooter className={styles['modal__footer']}>
          <Condition statement={showSecondaryButton}>
            <Button onClick={onClickSecondaryButton || onResetModal} className={styles['modal__button--secondary']}>
              <TextSemiBold className={styles['modal__text-secondary-button']}>{secondaryButtonText}</TextSemiBold>
            </Button>
          </Condition>
          <Condition statement={showPrimaryButton}>
            <Button className={styles['modal__error--primary-button']} onClick={onClickPrimaryButton}>
              <TextSemiBold className={styles['modal__text--primary-button']}>{primaryButtonText}</TextSemiBold>
            </Button>
          </Condition>
        </ModalFooter>
      </Condition>
    </>
  );
};

const ModalWarning = ({ modalProps }) => {
  const {
    contentTitle,
    contentDescription,
    showSecondaryButton,
    showPrimaryButton,
    onClickSecondaryButton,
    onResetModal,
    secondaryButtonText,
    onClickPrimaryButton,
    primaryButtonText,
    otherContent,
  } = modalProps;
  return (
    <>
      <ModalBody className={styles['modal__body']}>
        <Box className={styles['modal__warning--body-container']}>
          <Box>
            <Image src={WarningIllustrator} className={styles['modal__warning--illustrator']} />
          </Box>
          <Box className={styles['modal__warning--body']}>
            <Box className={styles['modal__warning--body-content']}>
              <TextBold className={styles['modal__warning--body-content-title']}>{contentTitle}</TextBold>
              <TextRegular className={styles['modal__warning--body-content-description']}>{contentDescription}</TextRegular>
            </Box>
            {otherContent}
          </Box>
        </Box>
      </ModalBody>
      <Condition statement={showPrimaryButton || showSecondaryButton}>
        <ModalFooter className={styles['modal__footer']}>
          <Condition statement={showSecondaryButton}>
            <Button onClick={onClickSecondaryButton || onResetModal} className={styles['modal__button--secondary']}>
              <TextSemiBold className={styles['modal__text-secondary-button']}>{secondaryButtonText}</TextSemiBold>
            </Button>
          </Condition>
          <Condition statement={showPrimaryButton}>
            <Button className={styles['modal__warning--primary-button']} onClick={onClickPrimaryButton}>
              <TextSemiBold className={styles['modal__text--primary-button']}>{primaryButtonText}</TextSemiBold>
            </Button>
          </Condition>
        </ModalFooter>
      </Condition>
    </>
  );
};

const ModalCancel = ({ modalProps }) => {
  const {
    contentDescription,
    contentHtmlDescription,
    showSecondaryButton,
    showPrimaryButton,
    onClickSecondaryButton,
    onResetModal,
    secondaryButtonText,
    onClickPrimaryButton,
    primaryButtonText,
  } = modalProps;
  return (
    <>
      <ModalBody className={styles['modal-cancel__body']}>
        <Condition
          statement={!contentHtmlDescription}
          children={<TextRegular>{contentDescription || ''}</TextRegular>}
          fallback={<Box dangerouslySetInnerHTML={{ __html: contentHtmlDescription }} />}
        />
      </ModalBody>
      <Condition statement={showPrimaryButton || showSecondaryButton}>
        <ModalFooter className={styles['modal_cancel__footer']}>
          <Condition statement={showSecondaryButton}>
            <Button onClick={onClickSecondaryButton || onResetModal} className={styles['modal-cancel__secondary-button']}>
              {secondaryButtonText}
            </Button>
          </Condition>
          <Condition statement={showPrimaryButton}>
            <Button className={styles['modal-cancel__primary-button']} onClick={onClickPrimaryButton}>
              {primaryButtonText}
            </Button>
          </Condition>
        </ModalFooter>
      </Condition>
    </>
  );
};

const ModalConfirm = ({ modalProps }) => {
  const {
    contentDescription,
    contentHtmlDescription,
    showSecondaryButton,
    showPrimaryButton,
    onClickSecondaryButton,
    onResetModal,
    secondaryButtonText,
    onClickPrimaryButton,
    primaryButtonText,
  } = modalProps;

  const isButtonAvailable = showPrimaryButton && showSecondaryButton;
  return (
    <>
      <ModalBody className={styles['modal-confirm__body']} mb={isButtonAvailable ? 'unset' : '24px'}>
        <Condition statement={!contentHtmlDescription} fallback={<Box dangerouslySetInnerHTML={{ __html: contentHtmlDescription }} />}>
          <TextRegular>{contentDescription}</TextRegular>
        </Condition>
      </ModalBody>
      <Condition statement={showPrimaryButton || showSecondaryButton}>
        <ModalFooter className={styles['modal_confirm__footer']}>
          <Condition statement={showSecondaryButton}>
            <Button onClick={onClickSecondaryButton || onResetModal} className={styles['modal-confirm__secondary-button']}>
              {secondaryButtonText}
            </Button>
          </Condition>
          <Condition statement={showPrimaryButton}>
            <Button className={styles['modal-confirm__primary-button']} onClick={onClickPrimaryButton}>
              {primaryButtonText}
            </Button>
          </Condition>
        </ModalFooter>
      </Condition>
    </>
  );
};

const CustomModal = () => {
  const modalProps = useModal();
  const { onOpenToast } = useToast();

  const { type, isOpen, onResetModal, title, width, maxWidth, isLockedModalOpen, customOnCloseModal } = modalProps;

  const onCloseModal = () => {
    if (isLockedModalOpen) {
      return onOpenToast({
        status: 'error',
        title: 'Error',
        description: 'Tidak bisa menutup modal!',
        duration: 3,
        alwaysShow: false,
      });
    }

    onResetModal();
    customOnCloseModal?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={width} maxWidth={maxWidth}>
        <ModalHeader className={styles['modal-header__header-container']}>
          <TextBold className={styles['modal-header__header-title']}>{title}</TextBold>
          <Condition
            statement={!isLockedModalOpen}
            children={<CloseIcon width="20px" height="20px" onClick={onResetModal} color="#333333" className={styles['modal-header__header-button-close']} />}
          />
        </ModalHeader>
        <Condition statement={type === 'success'}>
          <ModalSuccess modalProps={modalProps} />
        </Condition>
        <Condition statement={type === 'error'}>
          <ModalError modalProps={modalProps} />
        </Condition>
        <Condition statement={type === 'warning'}>
          <ModalWarning modalProps={modalProps} />
        </Condition>
        <Condition statement={type === 'cancel'}>
          <ModalCancel modalProps={modalProps} />
        </Condition>
        <Condition statement={type === 'confirm'}>
          <ModalConfirm modalProps={modalProps} />
        </Condition>
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;
